import React, { memo } from 'react';

import { Container, InformationWrapper } from './styled';
import InformationItem from './TableItem';
import { Information } from './types';

type Props = {
  informationItems: {
    title: string;
    information: Information[];
  }[];
  dataTestId?: string;
};

const InformationTable = ({ informationItems, dataTestId = 'informationTable' }: Props): JSX.Element => {
  return (
    <Container data-testid={dataTestId}>
      {informationItems.map((informationItem, index) => (
        <InformationWrapper key={index}>
          <InformationItem
            data-testid="informationItem"
            title={informationItem.title}
            information={informationItem.information}
          />
        </InformationWrapper>
      ))}
    </Container>
  );
};

export default memo(InformationTable);
